

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { RiferimentiPosizioneDTO } from "../dto/riferimento-posizioneDTO";
import { MapperTipoIstanzaFascicolo } from "./mapper-tipo-istanza-fascicolo";
import { RiferimentiPosizioneVO } from "../vo/riferimenti-posizioneVO";
import { ElementoVicinoDTO } from "../dto/elemento-vicinoDTO";
import { ElementoVicinoVO } from "../vo/elemento-vicinoVO";



@Injectable({
    providedIn: 'root'
})
export class MapperElementoVicino implements MapperInterface<ElementoVicinoDTO, ElementoVicinoVO> {
    constructor(private mapperTipoFascicolo: MapperTipoIstanzaFascicolo) {

    }
    convertVoToDto(vo: ElementoVicinoVO): ElementoVicinoDTO {
        if (vo != null) {
            const dto = new ElementoVicinoDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.idElemento = vo.idElemento;
            dto.tipoElemento = vo.tipoElemento;

            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: ElementoVicinoDTO): ElementoVicinoVO {
        if (dto != null) {
            const vo = new ElementoVicinoVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.idElemento = dto.idElemento;
            vo.tipoElemento = dto.tipoElemento;
            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: ElementoVicinoVO[]): ElementoVicinoDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: ElementoVicinoDTO[]): ElementoVicinoVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
